import React from 'react';
import TabContainer from '../../components/tab/TabContainer';
import TabDetail from './TabItems/TabDetail';
import TabDetailChange from './TabItems/TabDetailChange';

function DetailVoucherHD7({
	data,
	readonly,
	view,
	selectRow,
	handleGetDataDetail,
	handleGetDataDetailChange,
	isFieldNt,
}) {
	return (
		<div className="dialog__content_edit_voucher__body box_detail_voucher_detail">
			{(!view || data) && (
				<TabContainer
					tabs={[
						{
							label: 'Trả lại',
							component: (
								<TabDetail
									data={data}
									readonly={readonly}
									handleGetDataDetail={handleGetDataDetail}
									view={view}
									selectRow={selectRow}
									isFieldNt={isFieldNt}
								/>
							),
						},
						{
							label: 'Đổi hàng',
							component: (
								<TabDetailChange
									data={data}
									readonly={readonly}
									handleGetDataDetailChange={handleGetDataDetailChange}
									view={view}
									selectRow={selectRow}
									isFieldNt={isFieldNt}
								/>
							),
						},
					]}
				/>
			)}
		</div>
	);
}

export default DetailVoucherHD7;
